import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'Home'
  },
  {
    displayName: 'Dashboards',
    iconName: 'home',
    route: 'template/dashboards',
    children: [
      {
        displayName: 'Analytical',
        iconName: 'point',
        route: 'template/dashboards/dashboard1'
      },
      {
        displayName: 'eCommerce',
        iconName: 'point',
        route: 'template/dashboards/dashboard2'
      }
    ]
  },
  {
    displayName: 'Frontend pages',
    iconName: 'app-window',
    route: 'template/front-pages',
    children: [
      {
        displayName: 'Home Page',
        iconName: 'point',
        route: 'template/front-pages/homepage'
      },
      {
        displayName: 'About Us',
        iconName: 'point',
        route: 'template/front-pages/about'
      },
      {
        displayName: 'Blog',
        iconName: 'point',
        route: 'template/front-pages/blog'
      },
      {
        displayName: 'Blog Details',
        iconName: 'point',
        route: 'template/front-pages/blog-details'
      },
      {
        displayName: 'Portfolio',
        iconName: 'point',
        route: 'template/front-pages/portfolio'
      },
      {
        displayName: 'Pricing',
        iconName: 'point',
        route: 'template/front-pages/pricing'
      },
      {
        displayName: 'Contact',
        iconName: 'point',
        route: 'template/front-pages/contact'
      }
    ]
  },
  {
    displayName: 'Apps',
    iconName: 'apps',
    route: 'template/apps',
    ddType: '',
    children: [
      {
        displayName: 'Chat',
        iconName: 'point',
        route: 'template/apps/chat'
      },
      {
        displayName: 'Calendar',
        iconName: 'point',
        route: 'template/apps/calendar'
      },
      {
        displayName: 'Email',
        iconName: 'point',
        route: 'template/apps/email/inbox'
      },
      {
        displayName: 'Contacts',
        iconName: 'point',
        route: 'template/apps/contacts'
      },
      {
        displayName: 'Contact List',
        iconName: 'point',
        route: 'template/apps/contact-list'
      },
      {
        displayName: 'Courses',
        iconName: 'point',
        route: 'template/apps/courses'
      },
      {
        displayName: 'Employee',
        iconName: 'point',
        route: 'template/apps/employee'
      },
      {
        displayName: 'Notes',
        iconName: 'point',
        route: 'template/apps/notes'
      },
      {
        displayName: 'Tickets',
        iconName: 'point',
        route: 'template/apps/tickets'
      },
      {
        displayName: 'Invoice',
        iconName: 'point',
        route: 'template/apps/invoice'
      },
      {
        displayName: 'ToDo',
        iconName: 'point',
        route: 'template/apps/todo'
      },
      {
        displayName: 'Kanban',
        iconName: 'point',
        route: 'template/apps/kanban'
      },
      {
        displayName: 'Blog',
        iconName: 'point',
        route: 'template/apps/blog',
        children: [
          {
            displayName: 'Post',
            iconName: 'point',
            route: 'template/apps/blog/post'
          },
          {
            displayName: 'Detail',
            iconName: 'point',
            route: 'template/apps/blog/detail/Early Black Friday Amazon deals: cheap TVs, headphones, laptops'
          }
        ]
      },
      {
        displayName: 'User Profile',
        iconName: 'point',
        route: 'template/apps/profile-details',
        children: [
          {
            displayName: 'Profile',
            iconName: 'point',
            route: 'template/apps/profile-details/profile'
          },
          {
            displayName: 'Followers',
            iconName: 'point',
            route: 'template/apps/profile-details/followers'
          },
          {
            displayName: 'Friends',
            iconName: 'point',
            route: 'template/apps/profile-details/friends'
          },
          {
            displayName: 'Gellary',
            iconName: 'point',
            route: 'template/apps/profile-details/gallery'
          }
        ]
      },
      {
        displayName: 'Ecommerce',
        iconName: 'point',
        route: 'template/apps/product',
        children: [
          {
            displayName: 'Product List',
            iconName: 'point',
            route: 'template/apps/product/product-list'
          },
          {
            displayName: 'Add Product',
            iconName: 'point',
            route: 'template/apps/product/add-product'
          },
          {
            displayName: 'Edit Product',
            iconName: 'point',
            route: 'template/apps/product/edit-product'
          },
          {
            displayName: 'Shop',
            iconName: 'point',
            route: 'template/apps/product/shop'
          }
        ]
      }
    ]
  },
  {
    displayName: 'Ui',
    iconName: 'components',
    route: 'template/ui-components',
    ddType: '',
    children: [
      {
        displayName: 'Badge',
        iconName: 'point',
        route: 'template/ui-components/badge'
      },
      {
        displayName: 'Expansion Panel',
        iconName: 'point',
        route: 'template/ui-components/expansion'
      },
      {
        displayName: 'Chips',
        iconName: 'point',
        route: 'template/ui-components/chips'
      },
      {
        displayName: 'Dialog',
        iconName: 'point',
        route: 'template/ui-components/dialog'
      },
      {
        displayName: 'Lists',
        iconName: 'point',
        route: 'template/ui-components/lists'
      },
      {
        displayName: 'Divider',
        iconName: 'point',
        route: 'template/ui-components/divider'
      },
      {
        displayName: 'Menu',
        iconName: 'point',
        route: 'template/ui-components/menu'
      },
      {
        displayName: 'Paginator',
        iconName: 'point',
        route: 'template/ui-components/paginator'
      },
      {
        displayName: 'Progress Bar',
        iconName: 'point',
        route: 'template/ui-components/progress'
      },
      {
        displayName: 'Progress Spinner',
        iconName: 'point',
        route: 'template/ui-components/progress-spinner'
      },
      {
        displayName: 'Ripples',
        iconName: 'point',
        route: 'template/ui-components/ripples'
      },
      {
        displayName: 'Slide Toggle',
        iconName: 'point',
        route: 'template/ui-components/slide-toggle'
      },
      {
        displayName: 'Slider',
        iconName: 'point',
        route: 'template/ui-components/slider'
      },
      {
        displayName: 'Snackbar',
        iconName: 'point',
        route: 'template/ui-components/snackbar'
      },
      {
        displayName: 'Tabs',
        iconName: 'point',
        route: 'template/ui-components/tabs'
      },
      {
        displayName: 'Toolbar',
        iconName: 'point',
        route: 'template/ui-components/toolbar'
      },
      {
        displayName: 'Tooltips',
        iconName: 'point',
        route: 'template/ui-components/tooltips'
      }
    ]
  },
  {
    displayName: 'Pages',
    iconName: 'clipboard',
    route: 'template/theme-pages',
    ddType: '',
    children: [
      {
        displayName: 'Treeview',
        iconName: 'point',
        route: 'template/theme-pages/treeview'
      },
      {
        displayName: 'Pricing',
        iconName: 'point',
        route: 'template/theme-pages/pricing'
      },
      {
        displayName: 'Account Setting',
        iconName: 'point',
        route: 'template/theme-pages/account-setting'
      },
      {
        displayName: 'FAQ',
        iconName: 'point',
        route: 'template/theme-pages/faq'
      },
      {
        displayName: 'Landingpage',
        iconName: 'point',
        route: 'template/landingpage'
      },
      {
        displayName: 'Widgets',
        iconName: 'point',
        route: 'template/widgets',
        children: [
          {
            displayName: 'Cards',
            iconName: 'point',
            route: 'template/widgets/cards'
          },
          {
            displayName: 'Banners',
            iconName: 'point',
            route: 'template/widgets/banners'
          },
          {
            displayName: 'Charts',
            iconName: 'point',
            route: 'template/widgets/charts'
          }
        ]
      },
      {
        displayName: 'Charts',
        iconName: 'point',
        route: 'template/charts',
        children: [
          {
            displayName: 'Line',
            iconName: 'point',
            route: '/template/charts/line'
          },
          {
            displayName: 'Gredient',
            iconName: 'point',
            route: '/template/charts/gredient'
          },
          {
            displayName: 'Area',
            iconName: 'point',
            route: '/template/charts/area'
          },
          {
            displayName: 'Candlestick',
            iconName: 'point',
            route: '/template/charts/candlestick'
          },
          {
            displayName: 'Column',
            iconName: 'point',
            route: '/template/charts/column'
          },
          {
            displayName: 'Doughnut & Pie',
            iconName: 'point',
            route: '/template/charts/doughnut-pie'
          },
          {
            displayName: 'Radialbar & Radar',
            iconName: 'point',
            route: '/template/charts/radial-radar'
          }
        ]
      },
      {
        displayName: 'Auth',
        iconName: 'point',
        route: '/',
        children: [
          {
            displayName: 'Login',
            iconName: 'point',
            route: '/authentication',
            children: [
              {
                displayName: 'Login 1',
                iconName: 'point',
                route: '/authentication/login'
              },
              {
                displayName: 'Boxed Login',
                iconName: 'point',
                route: '/authentication/boxed-login'
              }
            ]
          },
          {
            displayName: 'Register',
            iconName: 'point',
            route: '/authentication',
            children: [
              {
                displayName: 'Login 1',
                iconName: 'point',
                route: '/authentication/side-register'
              },
              {
                displayName: 'Boxed Login',
                iconName: 'point',
                route: '/authentication/boxed-register'
              }
            ]
          },
          {
            displayName: 'Forgot Password',
            iconName: 'point',
            route: '/authentication',
            children: [
              {
                displayName: 'Side Forgot Password',
                iconName: 'point',
                route: '/authentication/side-forgot-pwd'
              },
              {
                displayName: 'Boxed Forgot Password',
                iconName: 'point',
                route: '/authentication/boxed-forgot-pwd'
              }
            ]
          },
          {
            displayName: 'Two Steps',
            iconName: 'point',
            route: '/authentication',
            children: [
              {
                displayName: 'Side Two Steps',
                iconName: 'point',
                route: '/authentication/side-two-steps'
              },
              {
                displayName: 'Boxed Two Steps',
                iconName: 'point',
                route: '/authentication/boxed-two-steps'
              }
            ]
          },
          {
            displayName: 'Error',
            iconName: 'point',
            route: '/authentication/error'
          },
          {
            displayName: 'Maintenance',
            iconName: 'point',
            route: '/authentication/maintenance'
          }
        ]
      }
    ]
  },
  {
    displayName: 'Forms',
    iconName: 'file-description',
    route: 'template/forms',
    ddType: '',
    children: [
      {
        displayName: 'Form elements',
        iconName: 'point',
        route: 'template/forms/forms-elements',
        children: [
          {
            displayName: 'Autocomplete',
            iconName: 'point',
            route: 'template/forms/forms-elements/autocomplete'
          },
          {
            displayName: 'Button',
            iconName: 'point',
            route: 'template/forms/forms-elements/button'
          },
          {
            displayName: 'Checkbox',
            iconName: 'point',
            route: 'template/forms/forms-elements/checkbox'
          },
          {
            displayName: 'Radio',
            iconName: 'point',
            route: 'template/forms/forms-elements/radio'
          },
          {
            displayName: 'Datepicker',
            iconName: 'point',
            route: 'template/forms/forms-elements/datepicker'
          }
        ]
      },
      {
        displayName: 'Form Layouts',
        iconName: 'point',
        route: '/forms/form-layouts'
      },
      {
        displayName: 'Form Horizontal',
        iconName: 'point',
        route: '/forms/form-horizontal'
      },
      {
        displayName: 'Form Vertical',
        iconName: 'point',
        route: '/forms/form-vertical'
      },
      {
        displayName: 'Form Wizard',
        iconName: 'point',
        route: '/forms/form-wizard'
      },
      {
        displayName: 'Toastr',
        iconName: 'point',
        route: '/forms/form-toastr'
      },
      {
        displayName: 'Editor',
        iconName: 'point',
        route: '/forms/form-editor'
      }
    ]
  },
  {
    displayName: 'Tables',
    iconName: 'layout',
    route: 'template/tables',
    ddType: '',
    children: [
      {
        displayName: 'Basic Table',
        iconName: 'point',
        route: 'template/tables/basic-table'
      },
      {
        displayName: 'Dynamic Table',
        iconName: 'point',
        route: 'template/tables/dynamic-table'
      },
      {
        displayName: 'Expand Table',
        iconName: 'point',
        route: 'template/tables/expand-table'
      },
      {
        displayName: 'Filterable Table',
        iconName: 'point',
        route: 'template/tables/filterable-table'
      },
      {
        displayName: 'Footer Row Table',
        iconName: 'point',
        route: 'template/tables/footer-row-table'
      },
      {
        displayName: 'HTTP Table',
        iconName: 'point',
        route: 'template/tables/http-table'
      },
      {
        displayName: 'Mix Table',
        iconName: 'point',
        route: 'template/tables/mix-table'
      },
      {
        displayName: 'Multi Header Footer',
        iconName: 'point',
        route: 'template/tables/multi-header-footer-table'
      },
      {
        displayName: 'Pagination Table',
        iconName: 'point',
        route: 'template/tables/pagination-table'
      },
      {
        displayName: 'Row Context Table',
        iconName: 'point',
        route: 'template/tables/row-context-table'
      },
      {
        displayName: 'Selection Table',
        iconName: 'point',
        route: 'template/tables/selection-table'
      },
      {
        displayName: 'Sortable Table',
        iconName: 'point',
        route: 'template/tables/sortable-table'
      },
      {
        displayName: 'Sticky Column',
        iconName: 'point',
        route: 'template/tables/sticky-column-table'
      },
      {
        displayName: 'Sticky Header Footer',
        iconName: 'point',
        route: 'template/tables/sticky-header-footer-table'
      },
      {
        displayName: 'Data table',
        iconName: 'point',
        route: 'template/datatable/kichen-sink'
      }
    ]
  }
];
